import React from 'react';
import PropTypes from 'prop-types';
import * as AppActions from '../../actions/AppActions';
import getContent from 'pp-react-l10n';
import { Checkbox } from '@paypalcorp/pp-react';

const CoverFeeCheckbox = ({
  handleCoverFeeChange,
  optInStatus,
  formatedFeeAmount,
  isDisabled,
}) => {
  const handleChange = (event) => {
    const isChecked = event.target.checked,
      checkboxStatus = isChecked ? 'checked' : 'unchecked';

    AppActions.changeCoverFee({
      coverFee: checkboxStatus,
    });

    handleCoverFeeChange(isChecked);
  };

  return (
    <Checkbox
      className="cover-fee-checkbox checkbox-bottom-margin"
      id="cover-fee-checkbox"
      data-testid="cover-fee-checkbox"
      name="coverFee"
      label={getContent('locals')('common/coverFee')(
        'labelA',
        { amount: formatedFeeAmount },
        { useHTML: true }
      )}
      value={optInStatus}
      onChange={handleChange}
      checked={optInStatus}
      disabled={isDisabled || false}
    />
  );
};

CoverFeeCheckbox.propTypes = {
  handleCoverFeeChange: PropTypes.func,
  optInStatus: PropTypes.bool,
  formatedFeeAmount: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default CoverFeeCheckbox;
